import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.051 42c8.735 0 16.552-7.575 16.552-16.535 0-4.916-2.37-9.831-5.915-12.555-1.112-.918-2.224-.79-2.869-.032-.709.79-.548 1.95.37 2.82 2.837 2.37 4.626 5.802 4.626 9.767a12.707 12.707 0 0 1-12.764 12.748c-7.075 0-12.78-5.69-12.78-12.764 0-6.012 4.11-11.008 9.67-12.378V15.2c0 1.305 1.305 1.692 2.272.95l5.141-3.916c.645-.5.645-1.434 0-1.917l-5.14-3.933c-.984-.757-2.273-.37-2.273.967v1.838C13.334 10.67 7.5 17.438 7.5 25.448 7.5 34.523 14.978 42 24.051 42Z",
    fill: "currentColor"
  }));
};

var SvgReplay = styled(SvgComponent).withConfig({
  displayName: "Replay__SvgReplay",
  componentId: "sc-1xhaj0w-0"
})(["", " ", ""], size, color);
export default SvgReplay;